<div class="admin-container">
    <div class="title-container"><span class="title">Activity</span></div>
    <div class="flex-container align-left">
        <div class="flex-field" *ngFor="let prospectField of this.activityProspectFields">
            <span class="size-text label-grid">{{ prospectField.label }}</span>
            <span class="size-text label-content-grid">
                <span class="status-field text-label" *ngIf="prospectField.label === 'STATUS'">
                    {{ prospectField.fieldValue | uppercase }}
                </span>
                <span *ngIf="!(prospectField.label === 'STATUS')">
                    <lsq-smart-truncate
                        [value]="prospectField.fieldValue"
                        [popoverValue]="prospectField.fieldValue"
                    ></lsq-smart-truncate>
                </span>
            </span>
        </div>
    </div>
</div>
